// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"397":"50f69b07","495":"20739783"}[chunkId] + ".chunk.css";
};